import React from "react";
import { makeStyles } from "@mui/styles";
import ArrowForwardContact from "src/assets/iconsSvg/arrowForwardContact";
import { colors } from "src/colors/colors";
import logoMbDefault from "../../assets/contract/logo-mb-hover.png";
import logoMbHover from "../../assets/contract/logo-mb-white-hover.png";
import { IResponseInquiryBill } from "../../interface/inquiryBill/responseInquiryBill";
import { useNavigate } from "react-router-dom";
import PATH from "src/routes/route-path";
import { FR_HEADER } from "src/const/const-from-env";
import ProductName from "src/screens/InfoPay/step2/component/productName";
interface PropsI {
  data?: IResponseInquiryBill;
}
const useStyles = makeStyles((theme) => {
  return {
    container: {
      [theme.breakpoints.up("xl")]: {
      },
    },
    containerContract: {
      ...theme.custom.flexBox.flexBetWeen,
      [theme.breakpoints.down("sm")]: {
        display: "block",
      },
    },
    contractItem: {
      ...theme.custom.flexBox.flexBetWeen,
      background: colors.white,
      width:"50%",
      maxWidth:"480px",
      padding: "20px 24px",
      borderRadius: "16px",
      color: colors.text.main,
      border: `2px solid #E0E0E0`,
      position: "relative",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        marginBottom: "16px",
        padding: "20px 16px",
      },
    },
    contentItem: {
      ...theme.custom.flexBox.flexAlignItemsCenter,
      marginBottom: "14px",
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
      },
    },
    contentItemContainer: {
    },
    containerIconForward: {
      minWidth: "40px",
      height: "40px",
      ...theme.custom.flexBox.flexCenterCenter,
      borderRadius: "50%",
      background: "#009FFF",
      [theme.breakpoints.down("md")]: {
        transform: "scale(0.7)",
      },
    },
    textDesc: {
      fontSize: "12px",
      lineHeight: "18px",
      minWidth:(props:IResponseInquiryBill) => props.data.initialPremium.totalAmt===null ? "136px" : "165px"
    },
    textTitle: {
      fontWeight: 600,
      lineHeight: "24px",
      fontSize: "14px",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
        lineHeight: "18px",
      },
    },
    textHeader: {
      fontWeight: 600,
      lineHeight: "20px",
      fontSize: "12px",
      marginBottom: "8px",
    },
    containerBg: {
      position: "absolute",
      top: "0",
      right: "0",
      bottom: "0",
      opacity: "0.5",
    },
    highLightContract: {
      background: "#009FFF",
      color: colors.white,
      cursor: "pointer",
    },
    highLightIcon: {
      border: `1px solid ${colors.white}`,
    },
  };
});

interface IParams {
  frSystm?: string
}

const ContractInsurance = ( props: PropsI) => {
  const params: IParams = Object.fromEntries(
    new URLSearchParams(location.search.split("?")[1])
  );
  const [idContract, setIdContract] = React.useState();
  const {data} = props
  const navigate = useNavigate();
  const classes = useStyles(data);
  const setIdContractHanlde = (id) => {
    setIdContract(id);
  };
  const onNextStep = () => {
    navigate(PATH.INFOPAY, { state: {data: data.data, frSystm: params?.frSystm ? params?.frSystm : FR_HEADER } });
  };
  return (
    <div className={classes.container}>
      <div className={classes.textHeader}>Tìm thấy 1 kết quả</div>
      <div className={classes.containerContract}>
        <div
          className={`${classes.contractItem} ${
            data.data.idNumber === idContract ? classes.highLightContract : ""
          }`}
          onMouseMove={() => setIdContractHanlde(data.data.idNumber)}
          onMouseOut={() => setIdContractHanlde(0)}
          onClick={onNextStep}
        >
          <div className={classes.containerBg}>
            <img
              src={
                data.data.idNumber === idContract ? logoMbHover : logoMbDefault
              }
              alt=""
              style={{ height: "100%" }}
            />
          </div>
          <div className={classes.contentItemContainer}>
            <div className={classes.contentItem}>
              <div className={classes.textDesc}>{data.data.initialPremium.totalAmt===null ? "Số hợp đồng bảo hiểm:" : "Mã hồ sơ yêu cầu bảo hiểm:"}</div>
              <div className={classes.textTitle}>{data.data.idNumber}</div>
            </div>
            <div className={classes.contentItem}>
              <div className={classes.textDesc}>Bên mua Bảo hiểm: </div>
              <div className={classes.textTitle}>{data.data.phName}</div>
            </div>
            <div className={classes.contentItem} style={{ marginBottom: "0" }}>
              <div className={classes.textDesc}>Sản phẩm Bảo hiểm: </div>
              <ProductName value={data.data.prdName} textAlign={"left"} />
            </div>
          </div>
          <div
            className={`${classes.containerIconForward} ${
              data.data.idNumber === idContract ? classes.highLightIcon : ""
            }`}
          >
            <ArrowForwardContact />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractInsurance;
